<template>
<div>
  <Top />
  <div class="maindiv zcollege-wrap bg-gray">
    <Banner :is-detail="true" :info="info"/>
    <div class="zddetail mt20 bgw htmldiv">
      <div class="fs24 btt prelative green pl25 lh10">专业计划</div>
      <div class="cont fs16 tc6 lh20 pt40 pl40" v-html="info.professional_programs"></div>
      <div class="fs24 btt prelative green pl25 lh10">时间轴</div>
      <div class="cont fs16 tc6 lh20 pt40 pl40" v-html="info.time_axis"></div>
      <div class="fs24 btt prelative green pl25 lh10">考试形式</div>
      <div class="cont fs16 tc6 lh20 pt40 pl40" v-html="info.examination_form"></div>
      <div class="fs24 btt prelative green pl25 lh10">报名须知</div>
      <div class="cont fs16 tc6 lh20 pt40 pl40" v-html="info.notice_for_application"></div>
    </div>
    <div class="ht30"></div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from "../top";
import Banner from "./bannerbf";
import Bottom from "../bottom";
export default {
  name: "detail",
  components:{
    Top,
    Banner,
    Bottom,
  },
  data () {
    return {
      'info':{},
    }
  },
  mounted() {
    $('.zddetail tr td').hover(
      function () {
        var p = $(this).closest('tr');
        if(p.find('td[rowspan]').length == 0 && $(this).siblings('td').length < 4){
          var tds = null;
          p.prevAll('tr').each(function(){
            if($(this).find('td[rowspan]').length > 0){
              tds = $(this).find('td[rowspan]');
              return false;
            }
          })
          if(tds)
            tds.addClass('active');
        }
        p.addClass('active');
      },
      function () {
        $('.zddetail .active').removeClass('active');
      }
    );
  },
  created() {
    var id = this.$route.query.id;
    var getParam = {};
    getParam['id'] = id;
    this.$request.get('major/detail',getParam,response => {
      if(response.status == 200){
        this.info = response.data.data;
      }
    },error => {
      console.log(error);
    })
  }
}
</script>

<style scoped>
  .zddetail{padding: 35px 40px 10px;}
  .zddetail table{margin: 40px 0 80px;width: 95%;border: 1px solid #888687;border-collapse: collapse;}
  .zddetail table thead td{position: sticky;top: 0;height: 30px;background: #fff;}
  .zddetail table .active{background: #5aaa59;color: #fff;}
  .zddetail table td{height: 36px;border: 1px solid #888687;}
  .btt::before{content: '';position: absolute;left: 0;top: 0;bottom: -2px;margin-right: 25px;width: 4px;}
  .btt.green::before{background: #3a8c39}

</style>



// WEBPACK FOOTER //
// src/components/cedu/professional/detail.vue